export default "__VITE_ASSET__YHk3vgxP__"